import ChartHeaderComponent, { ChartHeaderProps } from './ChartHeader.component';

type ChartHeaderPropss = ChartHeaderProps;

const ChartHeader = (props: ChartHeaderPropss): JSX.Element => {
  return <ChartHeaderComponent {...props} />;
};
export default ChartHeader;
